import { reactive } from "vue";

// state encapsulated and managed by the composable
const webchatGlobalNonpersistedState = reactive({
    showWebchatButton: false,
    shouldLaunchSierra: false,
});

export const webchatHelper = () => {
    function launchWebchat() {
        if (webchatGlobalNonpersistedState.shouldLaunchSierra) {
            window.dispatchEvent(new CustomEvent("launch-sierra-webchat")); // launches the sierra chat
        } else {
            window.embedded_svc.bootstrapEmbeddedService(); // launches the salesForce prechat form
        }
    }

    return { webchatGlobalNonpersistedState, launchWebchat };
};
